import type { InstallTestVx, InstallTestVxResult } from "~domain/install-tests/models/vx/install-test-vx-model.ts";
import type { InstallTestService } from "~domain/install-tests/services/install-test-service.ts";

import { EInstallTestState } from "~domain/install-tests/models/install-test-state-model.ts";

/**
 * It's really a bad practice, but the backoffice just gives us a string, so....
 */
const installTestOkResults = ["OK", "Mesure OK et coupure OK", "TIC détectée et activée"];

const installTestUnknownResults = [
  "Inconnu",
  "TIC non détectée",
  "TIC détectée mais non déclarée",
  "TIC non détectée et non déclarée",
  "Mesure OK mais non déclarée",
];

export class VxInstallTestService implements InstallTestService<InstallTestVx, InstallTestVxResult> {
  getInstallTestState(installTest: InstallTestVx): EInstallTestState {
    let state: EInstallTestState = EInstallTestState.OK;
    for (const result of installTest.results) {
      const resultState = this.getInstallTestStateForResult(result);
      if (resultState === EInstallTestState.UNKNOWN) {
        state = EInstallTestState.UNKNOWN;
        continue;
      }

      if (resultState === EInstallTestState.NOK) {
        state = EInstallTestState.NOK;
        break;
      }
    }

    return state;
  }

  getInstallTestStateForResult(installTestResult: InstallTestVxResult): EInstallTestState {
    if (installTestOkResults.includes(installTestResult.testResult)) {
      return EInstallTestState.OK;
    }

    if (installTestUnknownResults.includes(installTestResult.testResult)) {
      return EInstallTestState.UNKNOWN;
    }

    return EInstallTestState.NOK;
  }
}
